import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Icon, IconName, Hyperlink, Radius, Spacing, Text } from 'zens-storybook'
import { Href, Link } from 'zens-router'

import { InfoBlock } from '../info'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    height: '100%',
  },
  grid: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: -Spacing.S,
  },
  dummy: {
    flex: 1,
    minWidth: 300,
    paddingHorizontal: Spacing.S,
  },
  item: {
    flex: 1,
    padding: Spacing.S,
    minWidth: 300,
    flexBasis: '50%',
  },
  card: {
    flex: 1,
    flexDirection: 'row',
    borderColor: Color.calmGrey,
    borderWidth: 1,
    borderRadius: Radius.M,
  },
  icon: {
    padding: Spacing.S,
    justifyContent: 'center',
    borderColor: Color.calmGrey,
    borderRightWidth: 1,
    borderRadius: Radius.M,
  },
  right: {
    padding: Spacing.S,
    justifyContent: 'space-evenly',
  },
})

interface Item {
  title: string
  icon: IconName
  href: Href
}

interface Props extends ViewProps {
  companyId: number
  buildingId: number
}

const InsightsTrendGrid = (props: Props) => {
  const { companyId, buildingId, style, ...otherProps } = props
  const { t } = useTranslation()

  const items: Item[] = [
    {
      title: t('By floor'),
      icon: 'layers',
      href: `/companies/${companyId}/insights/${buildingId}/trend/floor`,
    },
    {
      title: t('By zone'),
      icon: 'location',
      href: `/companies/${companyId}/insights/${buildingId}/trend/zone`,
    },
    {
      title: t('By workspace type'),
      icon: 'desk',
      href: `/companies/${companyId}/insights/${buildingId}/trend/workspacetype`,
    },
    {
      title: t('By weekday'),
      icon: 'calendar',
      href: `/companies/${companyId}/insights/${buildingId}/trend/weekday`,
    },
  ]

  const renderItem = (item: Item) => (
    <View style={styles.item} key={item.icon}>
      <View style={styles.card}>
        <View style={styles.icon}>
          <Icon name={item.icon} size="L" color={Color.darkerBlue} />
        </View>
        <View style={styles.right}>
          <Text level={4}>{item.title}</Text>
          <Link href={item.href} asChild>
            <Hyperlink
              left="graph"
              title={t('View report')}
              right={<Icon name="right" size="S" color={Color.modifiedGrey} />}
            />
          </Link>
        </View>
      </View>
    </View>
  )

  return (
    <InfoBlock
      title={t('Occupancy trends')}
      style={[styles.container, style]}
      contentStyle={styles.content}
      {...otherProps}
    >
      <View style={styles.grid}>
        {items.map(renderItem)}
        <View style={styles.dummy} />
      </View>
    </InfoBlock>
  )
}

export default InsightsTrendGrid
